import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SailingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sailing"}/>
}
